module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    attrs: {
      "inline": true,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "powerGen",
      "label": "Produces"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Power Kw/H",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.power.powerGen),
      callback: function($$v) {
        _vm.$set(_vm.power, "powerGen", $$v)
      },
      expression: "power.powerGen"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("Kw/H")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "powerGenType",
      "label": "Power Source"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select...",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.power.powerGenType),
      callback: function($$v) {
        _vm.$set(_vm.power, "powerGenType", $$v)
      },
      expression: "power.powerGenType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "Genset"
    }
  }, [_vm._v("Genset")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "Grid Power"
    }
  }, [_vm._v("Grid Power")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "Solar"
    }
  }, [_vm._v("Solar")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "Wind"
    }
  }, [_vm._v("Wind")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "Micro-Hydro"
    }
  }, [_vm._v("Micro-Hydro")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b4ef106"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/features/PowerGen.vue
// module id = 1539
// module chunks = 0